export const LAND_USE = [
  { key: "population", label: "Population" },
  // { key: "lu_tree_cover", label: "Tree cover" },
  { key: "lu_shrubland", label: "Shrubland" },
  { key: "lu_grassland", label: "Grassland" },
  { key: "lu_cropland", label: "Cropland" },
  // { key: "lu_built_up", label: "Built-up" },
  { key: "lu_bare", label: "Bare" },
  // { key: "lu_water", label: "Water" },
  // { key: "lu_snow_ice", label: "Snow/Ice" },
  { key: "lu_wetland", label: "Wetland" },
  { key: "lu_mangroves", label: "Mangroves" },
  // { key: "lu_moss_lichen", label: "Moss/Lichen" },
];
